export default {
  WHATSAPP_PHONE: '+55 21 97376-4379',

  // Planos com desconto próprio, que não aceitam cupom de desconto acumulado.
  HIDE_COUPON_PLAN_IDS: [
    'whitebook_mensal_2021',
    'whitebook_mensal_estudantes_a2_2025',
    'whitebook_mensal_estudantes_b2_2025',
    'whitebook_mensal_medicos_b2_2026',
    'whitebook_anual_parcelado_medicos_b1_2026',
    'whitebook_anual_medicos_b1_2026',
    'whitebook_mensal_medicos_a2_2026',
    'whitebook_anual_parcelado_medicos_a1_2026',
    'whitebook_anual_medicos_a1_2026',
  ],
};
